import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ExpenseService from "../../services/expense.service";

export const getExpense = createAsyncThunk(
  "expense/getExpense",
  async (item, thunkAPI) => {
    try {
      const response = await ExpenseService.getExpense(item);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const addExpense = createAsyncThunk(
  "expense/addExpense",
  async (data, thunkAPI) => {
    try {
      const response = await ExpenseService.addExpense(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);



const initialState = {
  loading: false,
  error: null,
  expense: [],

};
const expenseSlice = createSlice({
  name: "fees",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder

      // ================= Fee Category =================

      .addCase(getExpense.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getExpense.fulfilled, (state, action) => {
        state.loading = false;
        state.expense = action.payload?.data || [];
      })
      .addCase(getExpense.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(addExpense.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addExpense.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(addExpense.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default expenseSlice.reducer;